<script>
import GlobalConfig from '@/global/config'
import { JobForm } from '@/views/cati/enum'

export default {
  name: 'TaskItem',
  props: {
    task: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isSelectTask() {
      return this.$route.query.taskId === this.task.id
    },
    taskType(){
      switch (this.task.jobForm) {
        case JobForm.FixedSample:
          return "固定样本"
        case JobForm.Prediction:
          return "预测式外呼"
      }
      return ""
    }
  },
  methods: {
    onChangeTask() {
      this.$emit('click')
      // console.log("123")
      // this.$route.query.taskId = this.task.id
    }
  }
}
</script>

<template>
  <div class="py-4 cati-task-item" :class="{'active-task':isSelectTask}" @click="onChangeTask">
    <div class="task-name mb-2">
<!--      <el-tag type="warning" size="mini">已分配</el-tag>-->
      <span class="font-bold">{{ task.executionName }}</span>
    </div>
    <div>
      <el-form label-width="120px">
        <el-form-item label="结算方式：">
          <div v-if="task.settleMethod==2">无</div>
          <div v-else>
            <template>
              <span v-if="task.settleMode === 1">按答卷数量</span>
              <span v-else-if="task.settleMode === 2">按天</span>
              <span v-else-if="task.settleMode === 3">按阶梯计价</span>
              <span v-else>-</span>
            </template>
            <template>
                            <span v-if="task.settleRule"
                            >{{
                                task.settleMode === 1 ? '，回收 ' : '，工作'
                              }}{{ task.settleRule.expectedQuantity }} {{
                                task.settleMode === 1 ? '份，' : '天，'
                              }}</span
                            >
              <span v-else>-</span>
            </template>
            <template>
              <div v-if="task.settleMode === 1">每份 {{ task.settleRule.unitPriceYuan }} 元</div>
              <div v-else-if="task.settleMode === 2">每天 {{ task.settleRule.unitPriceYuan }} 元</div>
              <div v-else-if="task.settleMode === 3">
                              <span>
                                每天回收 1~{{
                                  task.settleRule.tiers[task.settleRule.tiers.length - 1].quantityUpperBound
                                }} 份
                              </span>
                <span v-if="task.settleRule.tiers.length === 1">
                                最高每份 {{ task.settleRule.tiers[0].unitPriceYuan }}元
                              </span>
                <span v-else>
                                最高每份 {{
                    task.settleRule.tiers[task.settleRule.tiers.length - 1].unitPriceYuan
                  }}元
                              </span>
              </div>
              <div v-else>-</div>
            </template>
          </div>
        </el-form-item>
        <el-form-item v-if="taskType" label="任务类型：">{{ taskType }}</el-form-item>
        <el-form-item label="任务截止时间：">{{ task.executionValidateTo }}</el-form-item>
        <!--        <el-form-item label="所属项目：">这是项目名称这是项目名这是项目名称是项目名...</el-form-item>-->
      </el-form>
    </div>
  </div>
</template>

<style scoped lang="scss">
.cati-task-item {
  cursor: pointer;

  &.active-task {
    @apply bg-theme-100;
  }
}

.task-name {
  @apply px-4 text-theme-black-850 text-medium;
}

.el-form-item {
  margin-bottom: 0 !important;
}
</style>
